export enum SellerMarketplaceTab {
    MyEngagement = 1,
    EngagementDocuments = 2,
    EngagementTimeline = 3,
    Buyers = 4,
    DeadlineDocket = 5,
    DataAndDocs = 6,
}

export const SellerMarketplaceTabs = [
    { id: SellerMarketplaceTab.MyEngagement, content: 'My Engagement' },
    {
        id: SellerMarketplaceTab.EngagementDocuments,
        content: 'Engagement Documents',
    },
    {
        id: SellerMarketplaceTab.EngagementTimeline,
        content: 'Engagement Timeline',
    },
    { id: SellerMarketplaceTab.Buyers, content: 'Buyers' },
    { id: SellerMarketplaceTab.DeadlineDocket, content: 'Deadline Docket' },
    { id: SellerMarketplaceTab.DataAndDocs, content: 'Practice Data & Docs' },
];
